export const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
export const duplicateSpaceRegex = /\s+/g;
